/**
 * SearchLogListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * SearchLogListReq
 */
export interface SearchLogListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 用户ID */
  user_id?: any
  /** 设备ID */
  device_id?: string
  /** 关键词包含 */
  keyword__like?: string
  /** 最小结果数 */
  result_count__gte?: number
  /** 最大结果数 */
  result_count__lte?: number
  /** 创建时间距今(如:7d,1h,30m) */
  created_at__since?: any
  /** 创建时间早于(如:7d,1h,30m) */
  created_at__before?: any
  /** 用户ID列表 */
  user_id__in?: any
}

/**
 * SearchLogListReq Schema
 */
export const SearchLogListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    user_id: {
      description: '用户ID',
      format: 'string',
      type: 'user',
      label: '用户ID',
    },
    device_id: {
      description: '设备ID',
      format: 'string',
      type: 'string',
      label: '设备ID',
    },
    keyword__like: {
      description: '关键词包含',
      format: 'string',
      type: 'string',
      label: '关键词包含',
    },
    result_count__gte: {
      description: '最小结果数',
      format: '*int',
      type: 'integer',
      label: '最小结果数',
    },
    result_count__lte: {
      description: '最大结果数',
      format: '*int',
      type: 'integer',
      label: '最大结果数',
    },
    created_at__since: {
      description: '创建时间距今(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '创建时间距今',
    },
    created_at__before: {
      description: '创建时间早于(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '创建时间早于',
    },
    user_id__in: {
      description: '用户ID列表',
      format: '[]string',
      type: 'user',
      label: '用户ID列表',
    },
  },
  type: 'object',
}
